import React from "react";
import { motion } from "framer-motion";

/**
 * Book cover — stylised gradient card with the character portrait floating inside.
 * Used across the shop, book cards and detail pages.
 */
export default function BookCover({ book, size = "md", animate = true }) {
  const dims = {
    sm: "aspect-[3/4] rounded-[1.25rem]",
    md: "aspect-[3/4] rounded-[1.75rem]",
    lg: "aspect-[3/4] rounded-[2.5rem]",
  }[size];

  const portrait = `/assets/portrait-${book.cover_char}.png`;

  return (
    <div
      className={`relative overflow-hidden shadow-[0_20px_60px_-20px_rgba(11,42,85,0.35)] ${dims}`}
      style={{
        background: `linear-gradient(160deg, ${book.color} 0%, ${book.accent}55 60%, ${book.color} 100%)`,
        border: `1px solid ${book.accent}55`,
      }}
      data-testid={`book-cover-${book.slug}`}
    >
      {/* Language badge */}
      <span
        className="absolute top-3 left-3 z-20 rounded-full px-2.5 py-1 text-[10px] font-bold tracking-[0.18em] uppercase text-white"
        style={{ background: book.accent }}
      >
        {book.language}
      </span>

      {/* Sparkle */}
      <span className="absolute top-3 right-3 z-20 text-lg" aria-hidden="true">✨</span>

      {/* Editorial title strip */}
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 px-4 z-10">
        <div className="font-display text-white/95 text-lg md:text-2xl leading-[0.95] font-semibold drop-shadow-[0_4px_18px_rgba(11,42,85,0.55)]">
          <span className="block font-script text-white/85 text-base md:text-lg -mb-1">
            Tonek i Duszek
          </span>
          {book.title}
        </div>
      </div>

      {/* Character portrait */}
      <motion.img
        src={portrait}
        alt=""
        aria-hidden="true"
        className="absolute -bottom-4 -right-4 w-[68%] object-contain drop-shadow-[0_18px_20px_rgba(11,42,85,0.25)]"
        animate={animate ? { y: [-4, 4, -4], rotate: [-2, 2, -2] } : undefined}
        transition={animate ? { duration: 5, repeat: Infinity, ease: "easeInOut" } : undefined}
      />

      {/* Volume ribbon */}
      <div className="absolute bottom-3 left-3 z-20">
        <span className="chip !bg-white/90 !border-white !text-[#051937] !py-1 !px-2 !text-[10px]">
          {book.pages} str · {book.ageRange}
        </span>
      </div>

      {/* Spine highlight */}
      <div
        className="absolute inset-y-0 left-0 w-1.5 pointer-events-none"
        style={{ background: `linear-gradient(180deg, rgba(255,255,255,0.6), rgba(255,255,255,0))` }}
      />
    </div>
  );
}
